'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var PULSE = 'pulse';
var PULSE_ARTICLE = 'pulseArticle';
var PULSE_PAGE = 'pulsePage';

exports.default = {
    PULSE: PULSE,
    PULSE_ARTICLE: PULSE_ARTICLE,
    PULSE_PAGE: PULSE_PAGE
};
//# sourceMappingURL=instance-names.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/trackers/instance-names.js
 ** module id = 303
 ** module chunks = 0
 **/